import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/lib/supabase';
import { useActiveMunicipio } from '@/context/ActiveMunicipioContext';

const DEFAULT_CATEGORIAS = [
  'Competências Transversais',
  'Tecnologias de Informação',
  'Gestão e Liderança',
  'Legislação e Regulamentação',
  'Financeiro e Contabilidade',
  'Saúde e Segurança',
  'Línguas',
  'Técnica Especializada',
  'Outra',
];

export function useCategoriasFormacao() {
  const { activeMunicipio } = useActiveMunicipio();
  const municipioId = activeMunicipio?.id ?? '00000000-0000-0000-0000-000000000001';
  const [categorias, setCategorias] = useState<string[]>(DEFAULT_CATEGORIAS);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await supabase
        .from('app_settings')
        .select('value')
        .eq('municipio_id', municipioId)
        .eq('key', 'formacao_categorias')
        .maybeSingle();
      if (data?.value && data.value.trim()) {
        setCategorias(data.value.split(',').map((c: string) => c.trim()).filter(Boolean));
      }
    } catch {
      // fallback para defaults
    } finally {
      setLoading(false);
    }
  }, [municipioId]);

  useEffect(() => {
    load();
  }, [load]);

  return { categorias, loading, refresh: load };
}